module.exports = __webpack_public_path__ + "img/insertCol.bdf160be.png";